module.exports = __webpack_public_path__ + "img/verification_email.d38f4a5f.png";